/** DTOs der HTTP-API. Der Client importiert diese Typen direkt. */
/** Höchstlänge der Begrüßung — ein Satz, kein Anschreiben. */
export const GREETING_MAX = 240;
//# sourceMappingURL=api.js.map